<template>
    <fb-form-body>

        <el-form :model="formData" :rules="rules" ref="form" label-width="200px" >



            <el-form-item label="Customer Name" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input  v-model="formData.name" placeholder="Customer Name"></el-input>
            </el-form-item>

            <el-form-item label="Room Number" prop="roomNum" :error="formErrorMsg.roomNum" class="fb-form-item">
                <hw-dict-select v-model="formData.roomNum" type-flag="ROOM_SETTING" placeholder="Select"></hw-dict-select>
            </el-form-item>

            <el-form-item label="Check In Time" prop="checkInTime" :error="formErrorMsg.checkInTime" class="fb-form-item">
                <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="formData.checkInTime"
                        type="datetime"
                        placeholder="Check In Time">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="Check Out Time" prop="checkOutTime" :error="formErrorMsg.checkOutTime" class="fb-form-item">
                <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="formData.checkOutTime"
                        type="datetime"
                        placeholder="Check Out Time">
                </el-date-picker>
            </el-form-item>





            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">Confirm</el-button>
                <el-button @click="handleReset('form')">Reset</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import HwDictSelect from "../../components/HwDictSelect";
    export default {
        name: "CheckInRecord",
        components: {HwDictSelect},
        data() {
            return {

                api:{
                   add:this.$api.checkInRecord.add
                },
                formErrorMsg:{
                    name: '',
                    roomNum: '',
                    checkInTime:'',
                    checkOutTime:''
                },
                formData: {
                    name: '',
                    roomNum: '',
                    checkInTime:'',
                    checkOutTime:''
                },
                rules: {
                    name: [
                        {required: true, message: 'Customer can not be empty', trigger: 'blur'},
                    ],
                    roomNum: [
                        {required: true, message: 'Room number can not be empty', trigger: 'blur'},
                    ],
                    checkInTime: [
                        {required: true, message: 'Check in time can not be empty', trigger: 'blur'},
                    ],
                    checkOutTime: [
                        {required: true, message: 'Check out time can not be empty', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.add,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            if(this.$route.query.parent){
                this.formData.parent = this.$route.query.parent
            }
        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }



</style>


<style>
    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>